import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage, injectIntl} from 'react-intl';
import {Field, reduxForm} from 'redux-form';
import Button from '../button/Button';
import FieldText from '../fields/fieldText/FieldText';

@injectIntl
@reduxForm({
  form: 'changePassword',
  validate: ({newPassword = '', newPasswordRepeated = ''}) => ({
    newPassword: newPassword.length >= 4
      ? undefined : <FormattedMessage id="section.auth.password.short"/>,
    newPasswordRepeated: newPassword === newPasswordRepeated
      ? undefined : <FormattedMessage id="section.auth.password.must-match"/>
  })
})
export default class ChangePasswordForm extends React.PureComponent {
  render() {
    const {intl, handleSubmit, submitting, error} = this.props;

    return (
      <form className="form" onSubmit={handleSubmit}>
        {error && <span className="form__error">{error}</span>}

        <Field
          name="currentPassword"
          type="password"
          placeholder={intl.formatMessage({id: 'section.auth.password.current'})}
          component={FieldText}
          className="field-text--modal"
        />

        <Field
          name="newPassword"
          type="password"
          placeholder={intl.formatMessage({id: 'section.auth.password.new'})}
          component={FieldText}
          className="field-text--modal"
        />

        <Field
          name="newPasswordRepeated"
          type="password"
          placeholder={intl.formatMessage({id: 'section.auth.password.repeat'})}
          component={FieldText}
          className="field-text--modal"
        />

        <Button full filled loading={submitting} disabled={submitting}>
          {intl.formatMessage({id: 'section.auth.password.action'})}
        </Button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./components/auth/ChangePasswordForm.js